import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { getMaxProductHeight } from "@NA/Utils/Utility";
import { TypographyProps } from "@insite/mobius/Typography";
import { Hidden, Modal, Typography } from "@insite/mobius/index";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

interface OwnProps {
    vendorName: any;
    view: any;
}

type Props = OwnProps;
export interface LBShippedByVendorStyles {
    lbShippedByGrid?: InjectableCss;
    lbShippedByList?: InjectableCss;
    lbShippedByMsgList?: TypographyProps;
}

export const lbShippedByVendorStyles: LBShippedByVendorStyles = {
        lbShippedByGrid: {
            css: css`
                font-weight: 700;
                font-size: 14px;
                color: ${ADIColors.darkBlack3};
                span {
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 1.5;
                    color: ${ADIColors.darkBlack3};
                    margin-right: 3.5px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css` font-size: 12px; color: ${ADIColors.darkBlack3};`,
                            css` font-size: 12px; color: ${ADIColors.darkBlack3};`,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css` font-size: 12px; color: ${ADIColors.darkBlack3};`,
                            css` font-size: 12px; color: ${ADIColors.darkBlack3};`,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        lbShippedByList: {
            css: css`
                font-weight: 700;
                font-size: 16px;
                color: ${ADIColors.darkBlack3};
                margin-bottom: 8px;
                min-height: initial !important;
                line-height: 1.5;
                span {
                    font-weight: 700;
                    font-size: 16px;
                    color: ${ADIColors.darkBlack3};
                    margin-right: 3.5px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css` font-size: 12px; `,
                            css` font-size: 12px; `,
                            css` font-size: 14px; margin-top: 5px; `,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css` font-size: 12px; `,
                    css` font-size: 12px; `,
                    css` font-size: 14px; margin-top: 5px; `,
                    null,
                    null,
                ],
                "max",
            )}
            `,
        },
        lbShippedByMsgList: {
            css: css`
                font-size: 16px;
                font-weight: 700;
                color: ${ADIColors.darkBlack3};
                span {
                    font-weight: 700;
                    font-size: 16px;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css` font-size: 12px; `,
                            css` font-size: 12px; `,
                            css` font-size: 14px; margin-top: 5px; `,
                            null,
                            null,
                        ],
                        "max",
                    )}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css` font-size: 12px; `,
                            css` font-size: 12px; `,
                            css` font-size: 14px; margin-top: 5px; `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
        },
        
    };

    
const styles = lbShippedByVendorStyles;
const LBShippedByVendor: FC<Props> = ({
    vendorName,
    view,
}) => {
   
    const [minStockHeight, setMinStockHeight] = useState(15);

    useEffect(() => {
        const maxStockAvailableHeight = getMaxProductHeight('[data-test-selector="stockAvailable"]');

        setMinStockHeight(maxStockAvailableHeight);
    }, []);

    if (!vendorName) {
        return null;
    }

    return (
        <>
            {view=="Grid" ? (
                <StyledWrapper {...styles.lbShippedByGrid} data-test-selector="stockAvailable">
                    <Typography>{translate("Shipped By")}</Typography>{vendorName}
                </StyledWrapper>
            ) : (
                <StyledWrapper {...styles.lbShippedByList} data-test-selector="stockAvailable">
                    <Typography {...styles.lbShippedByMsgList}>
                        <Typography>{translate("Shipped By")}</Typography>{vendorName}
                    </Typography>
                </StyledWrapper>
            )}
        </>
    );
};

export default LBShippedByVendor;
